"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useAppStateStore_1 = __importDefault(require("./useAppStateStore"));
const AppStateConstants_1 = require("../types/AppStateConstants");
const useAppStateUpdateControlById = () => {
    const store = (0, useAppStateStore_1.default)();
    return (0, react_1.useCallback)((args) => {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.BO_UPDATE_CONTROL_BY_ID,
            payload: args,
        });
    }, [store]);
};
exports.default = useAppStateUpdateControlById;
